/* eslint-disable camelcase */
// node modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import FavoriteOutlinedIcon from '@material-ui/icons/FavoriteOutlined';

// app modules: components
import CollectionImage from 'components/CollectionImage';
import Link from 'components/Link';

// assets
import CssCollectionCollectionItem from './CollectionItem.scss';

class FavouriteCollectionItem extends PureComponent {
  static propTypes = {
    mobileViewAsList: PropTypes.bool,
    referrer: PropTypes.string,
    section: PropTypes.string,
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    mobileViewAsList: false,
    referrer: null,
    section: null,
  };

  render() {
    const { mobileViewAsList, referrer, section, t } = this.props;

    return (
      <div
        className={classNames('collection-item', {
          'collection-item--mobile-list': mobileViewAsList,
        })}
      >
        <Link
          className={classNames('collection-item__wrapper', {
            'collection-item--mobile-list__wrapper': mobileViewAsList,
          })}
          to={`/${t('favorites')}`}
          referrer={referrer}
          section={section}
        >
          <div
            className={classNames('collection-item__image', {
              'collection-item--mobile-list__image': mobileViewAsList,
            })}
          >
            <CollectionImage
              mobileAsThumbnail
              iconImage={
                <div>
                  <FavoriteOutlinedIcon
                    color="primary"
                    fontSize="large"
                    className="collection-item__fav-icon collection-item__fav-icon--outlined"
                  />
                  <FavoriteOutlinedIcon
                    color="primary"
                    fontSize="large"
                    className="collection-item__fav-icon collection-item__fav-icon--filled"
                  />
                </div>
              }
              theme="plain"
              width={250}
              height={250}
              bookCoverWidth={175}
              bookCoverHeight={175}
            />
          </div>

          <div
            className={classNames('collection-item__body', {
              'collection-item--mobile-list__body': mobileViewAsList,
            })}
          >
            <header
              className={classNames('collection-item__header', {
                'collection-item--mobile-list__header': mobileViewAsList,
              })}
            >
              My {t('Favorites')}
            </header>
          </div>
        </Link>
        {/* Interactive elements are overlayed using CSS to avoid nesting them inside the <a> tag. */}
        <div
          className={classNames('collection-item__actions-wrapper', {
            'collection-item--mobile-list__actions-wrapper': mobileViewAsList,
          })}
        >
          <div
            className={classNames('collection-item__actions', {
              'collection-item--mobile-list__actions': mobileViewAsList,
            })}
          />
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(CssCollectionCollectionItem)(FavouriteCollectionItem));
